const CompanyId = 'companyId'
const CompanyName = 'companyName'

export const CompanyRepository = {
  saveCompanyIdToLocalStorage: (companyId: number) => {
    localStorage.setItem(CompanyId, `${companyId}`)
  },
  saveCompanyNameToLocalStorage: (companyName: string) => {
    localStorage.setItem(CompanyName, companyName)
  },

  loadCompanyIdToLocalStorage: (): number | null => {
    const storageValue: string | null = localStorage.getItem(CompanyId) ?? null
    return storageValue ? Number.parseInt(storageValue) : null
  },
  loadCompanyNameToLocalStorage: (): string | null => {
    const storageValue: string | null = localStorage.getItem(CompanyName) ?? null
    return storageValue ?? null
  },

  removeCompanyIdFromLocalStorage: () => {
    localStorage.removeItem(CompanyId)
  },
  removeCompanyNameFromLocalStorage: () => {
    localStorage.removeItem(CompanyName)
  },
} as const
